import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { Label } from '@tiendanube/components';

export type ReasonType =
  | 'orderNew'
  | 'orderCancelled'
  | 'orderReopened'
  | 'orderEdition'
  | 'productCreation'
  | 'stockEdition'
  | 'stockTransferIn'
  | 'stockTransferOut'
  | 'stockReserved'
  | 'stockFreed'
  | 'deleteLocation';

interface LabelReasonProps {
  reason: ReasonType;
}

function LabelReason({ reason }: LabelReasonProps): JSX.Element {
  const { t } = useTranslation(Domain.CATALOG);

  const label = t(`products.stockHistoryModal.reason.${reason}`);

  return <Label id={reason} label={label} />;
}

export default LabelReason;
